import type { CaseStatusCode } from "../interfaces/statusCode.interface";

export function getStatusCodeValue(code: number) {
    const statusCode = statusCodes[code as number as keyof CaseStatusCode];
    return statusCode;
}

export function getStatusColor(code: number) {
    const statusColor = statusColors[code as number as keyof CaseStatusCode];
    return statusColor;
}
// const oprettetColor = "#d1d1d1";
// const igangvaerendeColor = "#e9c484";
// const afventerColor = "#f9dcd1";
// const besvaretColor = "#EAFFE7";
// const afsluttetColor = "#89be44";
// const annulleretColor = "#fefefe";
const oprettetColor = "#d7e1ac";
const igangvaerendeColor = "#e6a05e";
const afventerColor = "#c8abe9";
const besvaretColor = "#63b476";
const afsluttetColor = "#6f83ce";
const annulleretColor = "#cccccc";

const statusColors: CaseStatusCode = {
    922520000: oprettetColor,
    1: igangvaerendeColor,
    2: igangvaerendeColor,
    4: igangvaerendeColor,
    922520004: igangvaerendeColor,
    922520005: igangvaerendeColor,
    3: afventerColor,
    922520001: besvaretColor,
    5: afsluttetColor,
    6: annulleretColor
};

const statusCodes: CaseStatusCode = {
    922520000: "Oprettet",
    1: "Igangværende",
    2: "Sag udskudt",
    3: "Afventer kunde",
    4: "Undersøger",
    5: "Sag afsluttet",
    6: "Annulleret",
    922520004: "Igangværende",
    922520005: "Igangværende",
    922520001: "Besvaret"
};
